// rule

import React, { useContext, useState, useRef } from "react";
import { get, isEmpty, isUndefined } from "lodash";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import moment from "moment";
import { Formik, Field } from "formik";
import {
  ManagePlanLayout,
  FieldTextarea,
  FieldDropSide,
  SearchableList,
  MultiSelectDropdown,
  DatePicker,
  DeleteWarning,
} from "../../../components";
import {
  MANAGE_PLAN_ROUTES,
  managePlanFormNames,
  formFields,
  FLOW_TYPES,
  getPathWithParam,
  required,
  usDateFormat,
  clearFieldValues,
  toMultiSelectValue,
  toMultiSelectValueById,
  transformToMultiselectSave,
  getAdvancedPathWithParam,
  getNumber,
  getParamsFromQueryString,
} from "../../../utils";
import {
  clearLocalCacheByModel,
  createPlanStore,
  setManagePlanLocalCache,
  setManagePlanToastInfo,
} from "../../../contexts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import participationPeriods from "../../../mocks/vestingParticipationPeriod.json";
import hirePeriods from "../../../mocks/vestingHirePeriod.json";
import additionalVestingOptions from "../../../mocks/additionalVestingOptions.json";
import vestingEmployeeClassification from "../../../mocks/vestingEmployeeClassification.json";
import CommonVestingRules from "../AddVestingContainer/CommonVestingRules";
import {
  getClassificationCodes,
  GetplanYos,
  getVesting,
  listVesting,
  getEmploymentStatusList,
  deleteAdditionalVesting,
} from "../../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";

const AddVestingRuleContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(createPlanStore);
  const { planId, flow, vestingId, additionalRuleId } = useRouterParams();
  const dirtyCheck = getParamsFromQueryString("dirtyCheck");
  const formName = managePlanFormNames.ADD_VESTING_RULE;
  const fields = formFields[formName];
  const vestingtDataState = get(state, "vesting", []);

  const apiData = get(state, "api.data")
    ? get(state, "api.data")
    : get(state, "api.reviewAndPlanDetail");
  const companyId = get(apiData, "companyId");
  const { response: vestingsList } = useRequest({
    method: listVesting,
    payload: planId,
    defaultResponse: [],
  });
  const intVestingId = parseInt(vestingId, 10);
  console.log("intVestingId", intVestingId);
  const { response: vesting } = useRequest({
    method: getVesting,
    payload: parseInt(intVestingId),
    defaultResponse: [],
  });
  const { response: getPlanYosDataInVesting, loading: yosLoading } = useRequest(
    {
      method: GetplanYos,
      payload: planId,
      defaultResponse: [],
    }
  );
  const { response: employmentStatusList } = useRequest({
    method: getEmploymentStatusList,
    payload: companyId,
    defaultResponse: [],
  });
  const vestingsListData = get(vestingsList, "vestings", []);
  const intAdditionalVestingId = parseInt(additionalRuleId);
  const vestingFormValues = get(vesting, "vesting", {});
  const vestingsLocalCache = get(state, "vestings", []);
  const localStateOfcurrentVesting = Array.isArray(vestingsLocalCache)
    ? vestingsLocalCache
        .filter((x) => x !== undefined)
        .find((_) => _.id == parseInt(vestingId))
    : {};

  console.log(
    "localStateOfcurrentVesting",
    localStateOfcurrentVesting,
    "vestingsLocalCache",
    vestingsLocalCache
  );
  const additionalVestingsData = localStateOfcurrentVesting?.additionalVestings
    ? localStateOfcurrentVesting?.additionalVestings
    : get(vestingFormValues, "additionalVestings", []);

  // const additionalVestingsData = get(
  //   vestingFormValues,
  //   "additionalVestings",
  //   []
  // );
  const isYOSApplicable = getPlanYosDataInVesting?.planYOS?.isPlanYOSApplicable;
  const formValues = get(additionalVestingsData, additionalRuleId, {});
  const [errorMsg, setErrorMsg] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [employeeClassifications, setEmployeeClassifications] = useState([]);
  const [errorMessage, setErrorMessages] = useState([]);
  const initialValues = {
    [fields.immediateVestingIndicator]: true,
    [fields.vestingPastPeriodComputation]: false,
    [fields.applyToAllStatuses]: get(formValues, "applyToAllStatuses", true),
  };
  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_VESTING,
        pathParam: [flow, planId, vestingId], // put the company id after crated
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      }),
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_VESTING,
        pathParam: [flow, planId, vestingId], // put the company id after crated
        queryParam: `?dirtyCheck=${dirtyCheck}`,
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_PLAN_ROUTES.ADD_VESTING_RULE,
            pathParam: [FLOW_TYPES.SAVE, planId, vestingId, additionalRuleId],
          })
        ),
    },
    // {
    //   label: "Save",
    //   variant: "primary",
    //   type: "submit",
    //   flow: [FLOW_TYPES.SAVE],
    // },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () => setShowWarning(true),
    },
  ];

  const DeleteToastMessage = "You are attempting to delete the Vesting Rule.";
  const DeleteToastMessageHead = "Delete Vesting Rule?";
  const [showWarning, setShowWarning] = useState(false);
  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const planData = get(state, "api.reviewAndPlanDetail", {});

  useDeepEffect(() => {
    if (!isEmpty(planData)) {
      getClassificationCodes(get(planData, "companyId", 0))
        .then((response) => {
          setEmployeeClassifications(
            response.map((val) => ({
              label: val.code + "-" + val.classificationName,
              value: val.id,
            }))
          );
        })
        .catch((error) => {
          //Handle Error
        });
    }
  }, [planData]);

  const errorCodes = {
    vestingDescription: "PL601",
    vestingOption: "PL604",
    additionalVestingDescription: "PL605",
    hirePeriod: "PL606",
    hireStartDate: "PL607",
    hireEndDate: "PL608",
    hireDate: "PL609",
    participationPeriod: "PL610",
    participationStartDate: "PL611",
    participationEndDate: "PL612",
    participationDate: "PL613",
    includedClassifications: "PL614",
    immediateVestingIndicator: "PL615",
    vestingPastPeriodComputation: "PL634",
    vestedAt: "PL616",
    vestingMethod: "PL617",
    hoursOfService: "PL618",
    elapsedTime: "PL619",
    vestingComputationalPeriod: "PL620",
    serviceCreditPeriod: "PL621",
    descriptionLength: "PL622",
    descriptionContent: "PL623",
    effectiveDateRange: "PL624",
    descriptionLength: "PL625",
    hireDateRange: "PL626",
    participationDateRange: "PL627",
    monthsRange: "PL628",
    hoursOfService: "PL629",
    vestingSchedule: "PL630",
    vestingScheduleTable: "PL631",
    vestingScheduleTablePercentage: "PL632",
    disregardPrior: "PL700",
    months: "PL701",
    hours: "PL702",
    //minHours:"PL703"
    activeEmployees: "PL653",
    activeEmployeesRange: "PL654",
    daily: "PL655",
    dailyRange: "PL656",
    weekly: "PL657",
    weeklyRange: "PL658",
    biWeekly: "PL659",
    biWeeklyRange: "PL660",
    semiMonthly: "PL661",
    semiMonthlyRange: "PL662",
    monthly: "PL663",
    monthlyRange: "PL664",
    quarterly: "PL665",
    quarterlyRange: "PL666",
    semiAnnually: "PL667",
    semiAnnuallyRange: "PL668",
    annually: "PL669",
    annuallyRange: "PL670",
    breakInServiceRules: "PL671",
    // tablePercentage1: "tablePercentage1",
    // tablePercentage2: "tablePercentage2",
    // tablePercentage3: "tablePercentage3",
    // tablePercentage4: "tablePercentage4",
    // tablePercentage5: "tablePercentage5",
    // vestingSchedule: "PL60",
    // firstYear: "PL60",
    // secondYear: "PL60",
    // thirdYear: "PL60",
    // fourthYear: "PL60",
    // fifthYear: "PL60",
  };
  const vestingScheduleTableValidations = (values) => {
    let errMsgs = [];
    const errMsgReq = errorCodes["vestingScheduleTable"] + " : " + "Required";
    const errMsgPercent =
      errorCodes["vestingScheduleTablePercentage"] +
      " : " +
      "Plan Vesting schedule percentage should be greater than or equal to previous schedule percentage and should not be greater than 100 each";
    const labelHeadings = [
      "firstYear",
      "secondYear",
      "thirdYear",
      "fourthYear",
      "fifthYear",
    ];
    for (let i in labelHeadings) {
      const value = get(values, labelHeadings[i]);
      if (value === null || value === "" || value === undefined) {
        if (!errMsgs.includes(errMsgReq)) {
          errMsgs.push(errMsgReq);
          break;
        }
      } else if (value > 100) {
        if (!errMsgs.includes(errMsgPercent)) {
          errMsgs.push(errMsgPercent);
          break;
        }
      } else if (i != 0) {
        const previousValue = get(values, labelHeadings[i - 1]);
        if (previousValue != "" && value < previousValue) {
          if (!errMsgs.includes(errMsgPercent)) {
            errMsgs.push(errMsgPercent);
          }
        }
      }
    }
    return errMsgs;
  };
  const getDataForSave = (values) => {
    return vestingsListData.map((item, index) => {
      const updatedValues = {
        ...formValues,
        ...values,
        applyToAllStatuses: values[fields.applyToAllStatuses],
        dateOfHire: {
          rule: getNumber(values[fields.hirePeriod]),
          startDate: values[fields.hireDate]
            ? usDateFormat(values[fields.hireDate])
            : usDateFormat(values[fields.hireStartDate]),
          endDate: usDateFormat(values[fields.hireDate])
            ? usDateFormat(values[fields.hireDate])
            : usDateFormat(values[fields.hireEndDate]),
        },
        hoursOfServiceForEmploymentStatus:
          !values[fields.applyToAllStatuses] &&
          values[fields.vestingMethod] == 1
            ? values.hoursOfServiceForEmploymentStatus
            : [],
        equivalencyHoursForEmploymentStatus:
          !values[fields.applyToAllStatuses] &&
          values[fields.vestingMethod] == 3
            ? values.equivalencyHoursForEmploymentStatus
            : [],
        dateOfParticipation: {
          participationRule: getNumber(values[fields.participationPeriod]),
          startDate: values[fields.participationDate]
            ? usDateFormat(values[fields.participationDate])
            : usDateFormat(values[fields.participationStartDate]),
          endDate: values[fields.participationDate]
            ? usDateFormat(values[fields.participationDate])
            : usDateFormat(values[fields.participationEndDate]),
        },
        vestingScheduleTable: values[fields.immediateVestingIndicator]
          ? undefined
          : {
              [fields.firstYear]: parseFloat(values[fields.firstYear]),
              [fields.secondYear]: parseFloat(values[fields.secondYear]),
              [fields.thirdYear]: parseFloat(values[fields.thirdYear]),
              [fields.fourthYear]: parseFloat(values[fields.fourthYear]),
              [fields.fifthYear]: parseFloat(values[fields.fifthYear]),
              sixthYear: 100,
            },
        [fields.includedClassifications]: [
          ...transformToMultiselectSave(
            (values[fields.includedClassifications] || []).filter(
              (val) =>
                !get(formValues, fields.includedClassifications, [])
                  .map((_) => _.employeeClassificationCodeId)
                  .includes(val)
            ),
            "employeeClassificationCodeId"
          ),
          ...get(
            formValues,
            fields.includedClassifications,
            []
          )?.filter((val) =>
            (values[fields.includedClassifications] || []).includes(
              val.employeeClassificationCodeId
            )
          ),
        ],
      };
      if (item.id === intVestingId) {
        let transformedData = {};
        if (isEmpty(formValues)) {
          transformedData = {
            ...item,
            additionalVestings: [...additionalVestingsData, updatedValues],
          };
          return transformedData;
        }

        transformedData = {
          ...item,
          additionalVestings: additionalVestingsData.map(
            (addtionVestingItem, addtionVestingIndex) => {
              if (addtionVestingIndex === intAdditionalVestingId) {
                return { ...addtionVestingItem, ...updatedValues };
              }
              return addtionVestingItem;
            }
          ),
        };
        return transformedData;
      }
      //return item;
    });
  };
  const validateData = (values) => {
    let errMsgs = [];

    if (
      values[fields.immediateVestingIndicator] === false &&
      values[fields.vestingSchedule] === 6
    )
      errMsgs = vestingScheduleTableValidations(values);

    if (values[fields.vestingSchedule] === 6) {
      setErrorMessages(errMsgs);
      //return errMsgs;
    }
    return errMsgs;
  };
  const PageValidations = (values, setFieldError) => {
    let pageError = false;
    for (let x in fields) {
      if (
        x === "hireStartDate" &&
        values[fields.hirePeriod] === 1 &&
        !values[x]
      ) {
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      }
      if (
        x === "participationStartDate" &&
        values["participationPeriod"] === 1 &&
        !values[x]
      ) {
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      }
      if (x === "vestingOption" && !values[x])
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (x === "immediateVestingIndicator" && isUndefined(values[x])) {
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      }
      if (
        x === "hirePeriod" &&
        (values[fields.vestingOption] === 1 ||
          values[fields.vestingOption] === 4) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "hireDate" &&
        (values[fields.hirePeriod] === 2 || values[fields.hirePeriod] === 3) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "participationPeriod" &&
        (values[fields.vestingOption] === 2 ||
          values[fields.vestingOption] === 5) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "participationDate" &&
        (values[fields.participationPeriod] === 2 ||
          values[fields.participationPeriod] === 3) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "vestingComputationalPeriod" &&
        values[fields.vestingMethod] !== 2 &&
        values[fields.immediateVestingIndicator] === false &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "includedClassifications" &&
        (values[fields.vestingOption] === 3 ||
          values[fields.vestingOption] === 4 ||
          values[fields.vestingOption] === 5) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);

      if (
        x === "vestedAt" &&
        values[fields.immediateVestingIndicator] === false &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);

      if (
        x === "breakInServiceRules" &&
        values[fields.immediateVestingIndicator] === false &&
        values[fields.breakInServiceApplicable] === true &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "vestingMethod" &&
        values[fields.immediateVestingIndicator] === false &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "computationPeriod" &&
        values[fields.immediateVestingIndicator] === false &&
        (values[fields.vestingMethod] === 1 ||
          values[fields.vestingMethod] === 3) &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "vestingSchedule" &&
        values[fields.immediateVestingIndicator] === false &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (
        x === "serviceCreditPeriod" &&
        values[fields.immediateVestingIndicator] === false &&
        values[fields.vestingMethod] !== 2 &&
        !values[x]
      )
        pageError = commonRequired(x, setFieldError, errorCodes[x]);
      if (x === "vestingDescription") {
        let err = "";
        if (!values[x] || values[x].trim().length == 0)
          err = "PL601 : Required";
        //err = requiredError(values[x], errorCodes[x]);
        if (values[x]?.length > 150)
          err =
            errorCodes["descriptionLength"] +
            " : " +
            "Vesting Description length should not Exceed  150 characters";
        // else if (
        //   err.length == 0
        // )
        //   err =
        //     errorCodes["vestingDescription"] +
        //     " : " +
        //     "Required";
        // else if (
        //   err.length == 0 &&
        //   !new RegExp("^[a-zA-z0-9.' ]+$").test(values[x])
        // )
        //   err =
        //     errorCodes["descriptionContent"] +
        //     " : " +
        //     "Vesting Description should contain only Alphabets, Numbers, Space, Dot and Apostrophe";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "hireEndDate" && values[fields.hirePeriod] === 1) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (
          values[fields.hireStartDate] != null &&
          values[fields.hireStartDate] != "" &&
          values[fields.hireEndDate] != null &&
          values[fields.hireEndDate] != "" &&
          values[x] < values[fields.hireStartDate]
        )
          err =
            errorCodes["hireDateRange"] +
            " : " +
            "Hired End Date should be greater than Hired Start Date";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "participationEndDate" && values["participationPeriod"] === 1) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (
          values[fields.participationEndDate] != null &&
          values[fields.participationEndDate] != "" &&
          values[fields.participationStartDate] != null &&
          values[fields.participationStartDate] != "" &&
          values[x] < values[fields.participationStartDate]
        )
          err =
            errorCodes["participationDateRange"] +
            " : " +
            "Participation End Date should be greater than Participation Start Date";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "elapsedTime" && values[fields.vestingMethod] === 2) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 24)
          err =
            errorCodes["monthsRange"] +
            " : " +
            "Months cannot be greater than 24";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (
        x === "hoursOfService" &&
        values[fields.vestingMethod] === 1 &&
        values[fields.applyToAllStatuses]
      ) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 1000)
          err =
            errorCodes["hoursOfServiceRange"] +
            " : " +
            "Number of hours of service should not be greater than 1000";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (
        x === "disregardPrior" &&
        values[fields.breakInServiceApplicable] === true &&
        values[fields.breakInServiceRules] === 2
      ) {
        if (!values[x])
          pageError = commonRequired(x, setFieldError, errorCodes[x]);
        if (values[x] === 0) {
          let err = "";
          err = requiredError(values[x], errorCodes[x]);
          err = "PL780" + " : " + "Value cannot be 0";
          setFieldError(x, err);
          if (err.length > 0) pageError = true;
        }
      }

      if (
        x === "months" &&
        values[fields.breakInServiceApplicable] === true &&
        values[fields.vestingMethod] === 2
      ) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[fields.months] < 12 || !values[x])
          err =
            errorCodes["months"] +
            " : " +
            "BIS Months should be greater than or equal to 12 months";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (
        x === "hours" &&
        values[fields.breakInServiceApplicable] === true &&
        values[fields.vestingMethod] !== 2
      ) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (
          values[fields.hours] !== null &&
          values[fields.hoursOfService] !== null &&
          values[fields.hours] > values[fields.hoursOfService]
        )
          err =
            errorCodes["hours"] +
            " : " +
            "BIS Hours cannot exceed Vesting Actual Hours setup";
        if (!values[fields.hours] || values[fields.hours] < 500)
          err = "PL704" + " : " + "Minimum allowed BIS hour is 500";
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (
        x === "activeEmployees" &&
        values[fields.vestingMethod] === 3 &&
        values[fields.applyToAllStatuses]
      ) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 1000)
          err = `${errorCodes["activeEmployeesRange"]} : Hours cannot be more than 1000`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "daily" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 24)
          err = `${errorCodes["dailyRange"]} : Hours cannot be more than 24`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "weekly" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 168)
          err = `${errorCodes["weeklyRange"]} : Hours cannot be more than 168`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "biWeekly" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 336)
          err = `${errorCodes["biWeeklyRange"]} : Hours cannot be more than 336`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "semiMonthly" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 384)
          err = `${errorCodes["semiMonthlyRange"]} : Hours cannot be more than 384`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "monthly" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 744)
          err = `${errorCodes["monthlyRange"]} : Hours cannot be more than 744`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "quarterly" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 2208)
          err = `${errorCodes["quarterlyRange"]} : Hours cannot be more than 2208`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
      if (x === "semiAnnually" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 4392)
          err = `${errorCodes["semiAnnuallyRange"]} : Hours cannot be more than 4392`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }

      if (x === "annually" && values[fields.vestingMethod] === 3) {
        let err = "";
        err = requiredError(values[x], errorCodes[x]);
        if (values[x] > 8760)
          err = `${errorCodes["annuallyRange"]} : Hours cannot be more than 8760`;
        setFieldError(x, err);
        if (err.length > 0) pageError = true;
      }
    }

    if (
      !values[fields.applyToAllStatuses] &&
      values[fields.vestingMethod] === 1
    ) {
      values.hoursOfServiceForEmploymentStatus.forEach((_, i) => {
        let err = "";
        if (!_.hoursOfService) err = "PL629 : Required";
        if (_.hoursOfService > 1000)
          err =
            "PL629 : Number of hours of service should not be greater than 1000";
        setFieldError(
          `hoursOfServiceForEmploymentStatus.${i}.hoursOfService`,
          err
        );
        if (err.length > 0) pageError = true;
      });
    }
    if (
      !values[fields.applyToAllStatuses] &&
      values[fields.vestingMethod] === 3
    ) {
      values.equivalencyHoursForEmploymentStatus.forEach((_, i) => {
        let err = "";
        if (!_.hoursOfService) err = "PL629 : Required";
        if (_.hoursOfService > 1000)
          err = "PL629 : Hours cannot be more than 1000";
        setFieldError(
          `equivalencyHoursForEmploymentStatus.${i}.hoursOfService`,
          err
        );
        if (err.length > 0) pageError = true;
      });
    }
    return pageError;
  };
  const requiredError = (x, errorCode = "PL600") => {
    if (!x) {
      return errorCode + " : Required";
    }
    return "";
  };
  const commonRequired = (x, setFieldError, errorCode = "PL600") => {
    setFieldError(x, errorCode + " : Required");
    return true;
  };

  const onFormSubmit = (values, { setFieldError }) => {
    const msg = validateData(values, setFieldError);
    const pageError = PageValidations(values, setFieldError);
    if (msg.length === 0 && pageError === false) {
      const { history } = props;
      dispatch(
        setManagePlanLocalCache({
          model: "vestings",
          data: getDataForSave(values),
        })
      );

      history.push(
        getPathWithParam({
          path: MANAGE_PLAN_ROUTES.ADD_VESTING,
          pathParam: [flow, planId, vestingId],
          queryParam: `?dirtyCheck=${dirtyCheck}`,
        })
      );
    }
  };

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;

  function safeMoment(date) {
    return date ? moment(date).format("MM/DD/YYYY") : null;
  }
  const handleClose = () => {
    setShowErrorModal(false);
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...formValues,
        // [fields.usePlanDefaultYOSIndicator]: isEdit
        //   ? isYOSApplicable
        //   : isUndefined(isYOSApplicable) || !isYOSApplicable
        //   ? false
        //   : null,
        [fields.hirePeriod]: get(formValues, "dateOfHire.rule"),
        [fields.hireStartDate]: safeMoment(
          get(formValues, "dateOfHire.startDate")
        ),
        [fields.hireEndDate]: safeMoment(get(formValues, "dateOfHire.endDate")),
        [fields.hireDate]:
          get(formValues, "dateOfHire.rule") !== 1
            ? safeMoment(get(formValues, "dateOfHire.startDate")) ||
              safeMoment(get(formValues, "dateOfHire.endDate"))
            : null,
        [fields.participationPeriod]: get(
          formValues,
          "dateOfParticipation.participationRule"
        ),
        [fields.participationStartDate]: get(
          formValues,
          "dateOfParticipation.startDate"
        ),
        [fields.participationEndDate]: get(
          formValues,
          "dateOfParticipation.endDate"
        ),
        [fields.participationDate]:
          get(formValues, "dateOfParticipation.participationRule") !== 1
            ? get(formValues, "dateOfParticipation.startDate") ||
              get(formValues, "dateOfParticipation.endDate")
            : null,
        [fields.firstYear]: get(formValues, "vestingScheduleTable.firstYear"),
        [fields.secondYear]: get(formValues, "vestingScheduleTable.secondYear"),
        [fields.thirdYear]: get(formValues, "vestingScheduleTable.thirdYear"),
        [fields.fourthYear]: get(formValues, "vestingScheduleTable.fourthYear"),
        [fields.fifthYear]: get(formValues, "vestingScheduleTable.fifthYear"),
        [fields.includedClassifications]: get(
          formValues,
          fields.includedClassifications,
          []
        )?.map((val) => val.employeeClassificationCodeId),
        [fields.applyToAllStatuses]: get(
          formValues,
          "applyToAllStatuses",
          true
        ),
        hoursOfServiceForEmploymentStatus:
          formValues.vestingMethod == 1
            ? get(formValues, "hoursOfServiceForEmploymentStatus", [])
            : [],
        equivalencyHoursForEmploymentStatus:
          formValues.vestingMethod == 3
            ? get(formValues, "equivalencyHoursForEmploymentStatus", [])
            : [],
      }}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        setFieldError,
        values,
        ...rest
      }) => {
        const handleConfirmClick = () => {
          setShowWarning(false);
          const payload = {
            vestingId: parseInt(formValues.id),
            planId: parseInt(planId),
            sourceList: "",
          };
          deleteAdditionalVesting(payload).then((response) => {
            if (response.isSuccessful) {
              const vesting = getDataForSave(values);
              const additional = vesting[0]?.additionalVestings?.map(
                (additionalVesting, index) => {
                  if (index === parseInt(intAdditionalVestingId)) {
                    return { ...additionalVesting, isDeleted: true };
                  }
                  return additionalVesting;
                }
              );
              dispatch(
                setManagePlanLocalCache({
                  model: "vestings",
                  data: vesting.map((i) => {
                    if (i.id === intVestingId) {
                      return { ...i, additionalVestings: additional };
                    }
                    return i;
                  }),
                })
              );

              history.push(
                getPathWithParam({
                  path: MANAGE_PLAN_ROUTES.ADD_VESTING,
                  pathParam: [FLOW_TYPES.SAVE, planId, vestingId],
                  queryParam: `?dirtyCheck=${dirtyCheck}`,
                })
              );
              dispatch(
                setManagePlanToastInfo({
                  showToast: true,
                  toastMessage: `Data deleted successfully`,
                })
              );
            } else {
              setShowWarning(false);
              var x = response.errorMessages;
              if (
                //x[0].controlName == null &&
                x[0].errorCode !== null &&
                x[0].message !== null
              ) {
                setErrorMsg(`${x[0].errorCode} : ${x[0].message}`);
              }
              setShowErrorModal(true);
            }
          });
        };
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const validateVestingDescription = (value) => {
          if (!value) return "Required";
          else if (value?.length > 150)
            return "Vesting Description length should not Exceed  150 characters";
          if (!new RegExp("^[a-zA-z0-9.' ]+$").test(value))
            return "Vesting Description should contain only Alphabets, Numbers, Space, Dot and Apostrophe";
          return null;
        };

        const selectedApplicableEmployeeClassification =
          values[fields.includedClassifications];

        const onVestingOptionChange = (value) => {
          const updatedValues = clearFieldValues({
            values,
            fieldsToClear: [
              fields.hirePeriod,
              fields.hireStartDate,
              fields.hireEndDate,
              fields.hireDate,
              fields.participationPeriod,
              fields.participationStartDate,
              fields.participationEndDate,
              fields.participationDate,
              fields.includedClassifications,
            ],
          });
          setValues({
            ...updatedValues,
            [fields.vestingOption]: value,
          });
        };
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManagePlanLayout
              buttons={buttons}
              pageFlow={flow}
              layoutHeader="Additional Vesting"
            >
              <p className="plan-sub-heading">Additional Vesting Rules</p>
              <Row>
                <Col md="7">
                  <Field
                    isRequired
                    name={fields.vestingDescription}
                    label="Vesting Description"
                    autoComplete="off"
                    value={values[fields.vestingDescription]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldTextarea}
                    //validate={required}
                    size="lg"
                  />
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <Field
                    size="md"
                    isRequired
                    label="Additional Vesting Option"
                    name={fields.vestingOption}
                    value={values[fields.vestingOption]}
                    disabled={isEdit && !isSave}
                    options={additionalVestingOptions.data}
                    popupContent={
                      <SearchableList
                        label="Select a Default Investment"
                        isNotTypeAhead
                        options={additionalVestingOptions.data}
                        onSelect={onVestingOptionChange}
                        selectedValue={values[fields.vestingOption]}
                        isRadio
                      />
                    }
                    //validate={required}
                    component={FieldDropSide}
                  />
                </Col>
              </Row>
              <Row>
                {[1, 4].includes(values[fields.vestingOption]) && (
                  <Col md="4">
                    <Field
                      size="md"
                      isRequired
                      label="Hire period"
                      name={fields.hirePeriod}
                      value={values[fields.hirePeriod]}
                      disabled={isEdit && !isSave}
                      options={hirePeriods.data}
                      popupContent={
                        <SearchableList
                          label="Select a Hire period"
                          isNotTypeAhead
                          options={hirePeriods.data}
                          onSelect={(value) => {
                            setValues({
                              ...values,
                              hireDate: "",
                              hireStartDate: "",
                              hireEndDate: "",
                            });
                            setFieldValue(fields.hirePeriod, value);
                            setFieldError(fields.hireDate, "");
                            setFieldError(fields.hireStartDate, "");
                            setFieldError(fields.hireEndDate, "");
                          }}
                          selectedValue={values[fields.hirePeriod]}
                          isRadio
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                )}
                {values[fields.hirePeriod] === 1 ? (
                  <>
                    <Col md="2">
                      <Field
                        size="sm"
                        isRequired
                        label="Start Date"
                        name={fields.hireStartDate}
                        value={
                          typeof values[fields.hireStartDate] === "string"
                            ? values[fields.hireStartDate]
                            : usDateFormat(values[fields.hireStartDate])
                        }
                        disabled={isEdit && !isSave}
                        isDatePicker
                        onClear={() => setFieldValue(fields.hireStartDate, "")}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.hireStartDate, value)
                            }
                            value={
                              typeof values[fields.hireStartDate] === "string"
                                ? values[fields.hireStartDate]
                                : usDateFormat(values[fields.hireStartDate])
                            }
                          />
                        }
                        // //={(value) => {
                        //   if (!value) return "Required";
                        //   else if (value > values[fields.hireEndDate])
                        //     return "Hire Period Start Date should not exceed Hire Period End Date";
                        //   return null;
                        // }}
                        component={FieldDropSide}
                      />
                    </Col>
                    <Col md="2">
                      <Field
                        size="sm"
                        isRequired
                        label="End Date"
                        name={fields.hireEndDate}
                        value={
                          typeof values[fields.hireEndDate] === "string"
                            ? values[fields.hireEndDate]
                            : usDateFormat(values[fields.hireEndDate])
                        }
                        disabled={isEdit && !isSave}
                        isDatePicker
                        onClear={() => setFieldValue(fields.hireEndDate, "")}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.hireEndDate, value)
                            }
                            value={
                              typeof values[fields.hireEndDate] === "string"
                                ? values[fields.hireEndDate]
                                : usDateFormat(values[fields.hireEndDate])
                            }
                          />
                        }
                        //validate={required}
                        component={FieldDropSide}
                      />
                    </Col>
                  </>
                ) : null}
                {values[fields.hirePeriod] === 2 ? (
                  <Col md="2">
                    <Field
                      size="sm"
                      isRequired
                      label="Hire Date"
                      name={fields.hireDate}
                      value={
                        typeof values[fields.hireDate] === "string"
                          ? values[fields.hireDate]
                          : usDateFormat(values[fields.hireDate])
                      }
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() => setFieldValue(fields.hireDate, "")}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.hireDate, value)
                          }
                          value={
                            typeof values[fields.hireDate] === "string"
                              ? values[fields.hireDate]
                              : usDateFormat(values[fields.hireDate])
                          }
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                ) : null}
                {values[fields.hirePeriod] === 3 ? (
                  <Col md="2">
                    <Field
                      size="sm"
                      isRequired
                      label="Hire Date"
                      name={fields.hireDate}
                      value={
                        typeof values[fields.hireDate] === "string"
                          ? values[fields.hireDate]
                          : usDateFormat(values[fields.hireDate])
                      }
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() => setFieldValue(fields.hireDate, "")}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.hireDate, value)
                          }
                          value={
                            typeof values[fields.hireDate] === "string"
                              ? values[fields.hireDate]
                              : usDateFormat(values[fields.hireDate])
                          }
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                ) : null}
              </Row>
              <Row>
                {[2, 5].includes(values[fields.vestingOption]) ? (
                  <Col md="4">
                    <Field
                      size="md"
                      isRequired
                      label="Participation period"
                      name={fields.participationPeriod}
                      value={values[fields.participationPeriod]}
                      disabled={isEdit && !isSave}
                      options={participationPeriods.data}
                      popupContent={
                        <SearchableList
                          label="Select a Participation period"
                          isNotTypeAhead
                          options={participationPeriods.data}
                          onSelect={(value) => {
                            setValues({ ...values, participationDate: "" });
                            setFieldValue(fields.participationPeriod, value);
                            setFieldError(fields.participationDate, "");
                          }}
                          selectedValue={values[fields.participationPeriod]}
                          isRadio
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                ) : null}
                {values[fields.participationPeriod] === 1 ? (
                  <>
                    <Col md="2">
                      <Field
                        size="sm"
                        isRequired
                        label="Start Date"
                        name={fields.participationStartDate}
                        value={usDateFormat(
                          values[fields.participationStartDate]
                        )}
                        disabled={isEdit && !isSave}
                        isDatePicker
                        onClear={() =>
                          setFieldValue(fields.participationStartDate, "")
                        }
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(
                                fields.participationStartDate,
                                value
                              )
                            }
                            value={usDateFormat(
                              values[fields.participationStartDate]
                            )}
                          />
                        }
                        // validate={(value) => {
                        //   if (!value) return "Required";
                        //   else if (value > values[fields.participationEndDate])
                        //     return "Participation Period Start Date should not exceed Participation Period End Date";
                        //   return null;
                        // }}
                        component={FieldDropSide}
                      />
                    </Col>
                    <Col md="2">
                      <Field
                        size="sm"
                        isRequired
                        label="End Date"
                        name={fields.participationEndDate}
                        value={usDateFormat(
                          values[fields.participationEndDate]
                        )}
                        disabled={isEdit && !isSave}
                        isDatePicker
                        onClear={() =>
                          setFieldValue(fields.participationEndDate, "")
                        }
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.participationEndDate, value)
                            }
                            value={usDateFormat(
                              values[fields.participationEndDate]
                            )}
                          />
                        }
                        //validate={required}
                        component={FieldDropSide}
                      />
                    </Col>
                  </>
                ) : null}
                {values[fields.participationPeriod] === 2 ? (
                  <Col md="2">
                    <Field
                      size="sm"
                      isRequired
                      label="Participation Date"
                      name={fields.participationDate}
                      value={usDateFormat(values[fields.participationDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.participationDate, "")
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.participationDate, value)
                          }
                          value={usDateFormat(values[fields.participationDate])}
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                ) : null}
                {values[fields.participationPeriod] === 3 ? (
                  <Col md="2">
                    <Field
                      size="sm"
                      isRequired
                      label="Participation Date"
                      name={fields.participationDate}
                      value={usDateFormat(values[fields.participationDate])}
                      disabled={isEdit && !isSave}
                      isDatePicker
                      onClear={() =>
                        setFieldValue(fields.participationDate, "")
                      }
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.participationDate, value)
                          }
                          value={usDateFormat(values[fields.participationDate])}
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                ) : null}
              </Row>
              {[3, 4, 5].includes(values[fields.vestingOption]) ? (
                <Row>
                  <Col md="4">
                    <Field
                      size="md"
                      isRequired
                      label="Applicable Employee Classifications"
                      name={fields.includedClassifications}
                      value={toMultiSelectValueById(
                        selectedApplicableEmployeeClassification,
                        employeeClassifications
                      )}
                      disabled={isEdit && !isSave}
                      isMultiSelect
                      popupContent={
                        <MultiSelectDropdown
                          label="Select Employee Classifications"
                          name={fields.includedClassifications}
                          onSelect={(value) =>
                            setFieldValue(fields.includedClassifications, value)
                          }
                          value={values[fields.includedClassifications]}
                          options={employeeClassifications}
                          disabled={isEdit && !isSave}
                        />
                      }
                      //validate={required}
                      component={FieldDropSide}
                    />
                  </Col>
                </Row>
              ) : null}
              <CommonVestingRules
                fields={fields}
                isEdit={isEdit}
                isSave={isSave}
                usePlanDefaultYOSIndicator={
                  formValues?.usePlanDefaultYOSIndicator
                }
                getPlanYosDataInVesting={getPlanYosDataInVesting}
                errorMessage={errorMessage}
                statusList={employmentStatusList}
              />
            </ManagePlanLayout>
            <DeleteWarning
              DeleteToastMessageHead={DeleteToastMessageHead}
              DeleteToastMessage={DeleteToastMessage}
              showModal={showWarning}
              handleConfirmClick={handleConfirmClick}
              handleCancelClick={handleCancelClick}
            />
            <Modal show={showErrorModal} onHide={handleClose}>
              <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
                <div className="text-right">
                  <FontAwesomeIcon
                    icon={faTimes}
                    color="#000"
                    onClick={handleClose}
                  />
                </div>
                <div className="d-flex">
                  <div className="pd-15">
                    <FontAwesomeIcon
                      icon={faExclamationTriangle}
                      color="#f94f50"
                      size="3x"
                    />
                  </div>
                  <div className="remove-text">
                    <p>{errorMsg}</p>
                    <br />
                    <Button className="cancel-btn" onClick={handleClose}>
                      Ok
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddVestingRuleContainer;
